import { useTranslations } from "next-intl"

const useFetcherLinks = () => {
  const translate = useTranslations('header.links')

  return [
    {
      tag: translate('home'),
      url: '/',
    },
    {
      tag: translate('knowledgeBase'),
      url: `/knowledge-base`,
    },
    {
      tag: translate('contact'),
      url: `/contact`,
    },
  ]
}

export default useFetcherLinks
